import * as wooutils from "./utils.js";


function view_item_gtm() {
    //console.log("view_item_gtm", data);

    var product_id = jQuery(".product_title").attr("data-productid");
    var product_name = jQuery(".product_title").attr("data-product_name");
    var product_price = jQuery(".product_title").attr("data-product_price");
    var product_sku = jQuery(".product_title").attr("data-product_sku");
    var qty = jQuery(this).closest("input[name=quantity]").val();
    qty = typeof (qty) !== "undefined" ? qty : 1;
    var product_variation = jQuery(".product_title").attr("data-product_variation");

    var data = {
        event: 'view_item',
        eventLabel: "View Product",
        eventCategory: "View Product",
        eventAction: "View Product",
        ecommerce: {
            "items": [{
                "id": parseInt(product_id),
                "item_id": product_sku,
                "item_name": product_name,
                "price": parseFloat(product_price),
                "quantity": qty,
                "item_variant": product_variation,
                'google_business_vertical': 'retail',
                'value': parseFloat(product_price),

            }]
        },
        'value': parseFloat(product_price),
    }

    console.log("pushing data to datalayer", data);

    window.dataLayer = window.dataLayer || []; // get or set the dataLayer
    dataLayer.push(data);
}

export function init() {

    if (jQuery("body").hasClass("page-id-15769")) {
        init_build_your_bike();
    }

    if (jQuery(".gform_body .stars .gfield_radio .gchoice").length > 0) {
        jQuery(".gform_body .stars .gfield_radio .gchoice").on("click", function () {
            jQuery(".gform_body .stars .gfield_radio .gchoice").addClass("on");
            jQuery(this).children("input").attr("checked", "checked");
            var thisval = jQuery(this).children("input").val();
            jQuery(".gform_body .stars .gfield_radio .gchoice").each(function () {
                var lessval = jQuery(this).children("input").val();
                if (lessval > thisval) {
                    jQuery(this).removeClass("on");
                }
            });
        });
    }

    if (jQuery("body").hasClass("single-product")) {

        view_item_gtm();

        var sel_variation = wooutils.get_selected_variation();

        if (sel_variation) {
            wooutils.showbuyform(sel_variation);
        }

        jQuery(".single_variation_wrap").on("show_variation", function (event, variation) {

            var vardetails = wooutils.get_selected_variation(variation.variation_id);

            console.log("vardetails: ", vardetails)
            var outofstock_title = vardetails.outofstock_title;
            var outofstock_button_text = vardetails.outofstock_button_text;



            if (outofstock_title) {
                jQuery(".stockcomingsoon .preordertitle").html(outofstock_title);

            }
            if (outofstock_button_text) {
                jQuery(".stockcomingsoon .productenquire").html(outofstock_button_text);
            }
            var price = vardetails.display_price;
            var variation_description = vardetails.variation_description;
            var sku = vardetails.sku;
            var variation_id = vardetails.variation_id;

            if (sku){
                jQuery(".sku").html("<b>SKU: </b> " + sku)
            }
            
            jQuery(".product_title").attr("data-productid", variation_id);
            jQuery(".product_title").attr("data-product_sku", sku);
            jQuery(".product_title").attr("data-product_price", price);
            jQuery(".product_title").attr("data-product_variation", variation_description);

            view_item_gtm();

            var imageid = vardetails.image_id;

            var thumbnail = jQuery(`.product_thumbnails img[data-imageid='${imageid}']`);
            var image = variation.image.src;
            jQuery(".productenquiryform").attr("data-image", image);

            var slideno = thumbnail.closest(".slide-item").attr("data-itemno");

            jQuery(".product_thumbnails").slick('slickGoTo', slideno - 1);
            wooutils.showbuyform(variation);

        });

        jQuery('div').on("click", ".productenquire", function () {
            //   console.log("productenquire click")
            var productTitle = jQuery(".product_title").html();
            var productform = jQuery(".productenquiryform").html();
            var productImageSrc = jQuery(".productenquiryform").attr("data-image");
            var productShort = jQuery(".product_meta").html();
            var popupcontent = `<div class="productenquirepopup ">
                <div class="vc_row">
                    <div class="vc_col-sm-8">
                    <h3>Enquire About : ${productTitle}</h3>
                    ${productform}
                    </div>
                    <div class="vc_col-sm-4"><img src="${productImageSrc}"><hr><div class="product_meta">${productShort}</div></div>
                </div>
            </div>`;
            jQuery.magnificPopup.open({
                mainClass: 'mfp-zoom-in',
                showCloseBtn: true,
                removalDelay: 200,
                items: {
                    alignTop: true,
                    overflowY: 'scroll',
                    src: popupcontent,
                    type: 'inline'
                },

                callbacks: {
                    open: function () {
                        //jQuery(el).html(html);
                        //jQuery(el).removeClass("btn-loading");
                        // init_vscroll();
                        // init_gtmtracking();
                        jQuery(".productenquirepopup .mfp-close").on('click', function (e) {
                            e.preventDefault();
                            jQuery.magnificPopup.close();
                        });

                        var jQuerypopup = jQuery('.themedev-product-popup');

                        setTimeout(function () {
                            jQuerypopup.addClass('animate-width');
                        }, 500);
                        setTimeout(function () {
                            jQuerypopup.addClass('add-content');
                        }, 1000);
                    },
                    // close: function () {
                    //     jQuery('.themedev-product-popup').remove();
                    // }
                }
            });
        })

        // var productid = jQuery("h1").attr("data-productid");
        // var variationid = (jQuery("input[name='variation_id']").length > 0) ? jQuery("input[name='variation_id']").val() : 0;

        // var carticons = `<div class="cart-tool clearfix"><a class="wishlist_toggle" data-productid="` + productid + `" data-toggle="tooltip" data-placement="top" title="" data-original-title="Add to wishlist"><i class="far fa fa-heart-o"></i></a></div>`;

        // jQuery(carticons).insertAfter(".cart .add_to_cart_button");

        // jQuery(".product_title").insertBefore(".product-price-wrap");
        // jQuery(".reset_variations").insertAfter(jQuery("table.variations"));

        jQuery(".starreviews").on("click", function () {
            gotoreviews()
        })
    }
}



export function show_closest_stockist(lat, lng, elid) {

    var thisel = jQuery("#" + elid).parent();

    //   console.log("postcode changed")

    thisel.html("<p align='center'><img src='/wp-content/themes/profem/assets/images/ajax-loading.gif' /></p>");

    jQuery.post(base.ajaxurl, {
        action: "closest_stockist",
        lat: lat,
        lng, lng
    }, function (r) {
        var r = JSON.parse(r);
        //       console.log(r)
        var stockistid = r.stockist.id;
        var stockistname = r.stockist.name;
        var stockistaddress = r.stockist.address;
        var distance = r.distance;

        // var productname = jQuery(".product_title").html();

        var productid = (jQuery("input[name='product_id']").length > 0) ? jQuery("input[name='product_id']").val() : (jQuery("button[name='add-to-cart']").length > 0) ? jQuery("button[name='add-to-cart']").val() : jQuery(".productwheretobuy").attr("data-productid");
        var variationid = (jQuery("input[name='variation_id']").length > 0) ? jQuery("input[name='variation_id']").val() : 0;

        productid = (variationid > 0) ? variationid : productid;
        var rHTML = "";

        if (stockistid == -1) {
            rHTML = "Sorry, there are currently no stockists in your area. Please contact profem for a direct shipping quote.";
            addtocart = "<span class='btn'>Click here to contact profem</span>";
        }
        else if (stockistid == 13918) {
            rHTML = "Your nearest store is us! profem -  " + distance + "km away.";

            //  
            //  rHTML = `<a data-quantity="1" class="button product_type_simple add_to_cart_button ajax_add_to_cart" data-product_id="${addtocartid}" aria-label="Add ${productname} to your cart" rel="nofollow">Purchase from profem</a>`;
        }
        else {
            rHTML = `Your nearest stockist is <b>${stockistname}</b> ${distance}km away.<br /><br />
            <a data-productid='${productid}' class='mts productenquire btn btn-primary'>Click here to send them an enquiry today</a>`;
        }


        thisel.html(rHTML);

        // jQuery(".stockistchecker .stockist").html(neareststockist + "<br /><br />" +  addtocart);
        // jQuery(".stockistchecker").on("click",".stockist span.btn",function(e){
        //     e.stopPropagation();
        //     jQuery(".productenquire").trigger("click");
        // });

        // jQuery(".stockistchecker .stockist").on("click",".addtocarttrigger",function(e){
        //     e.stopPropagation();

        //     jQuery(".single_add_to_cart_button").trigger("click");

        // });
    });
}
